export function getBusinessSpecificFields(businessType) {
  if (businessType === "Restaurant") {
    return [
      {
        type: "boolean",
        name: "order_booked",
        description: "Set to true ONLY after the customer explicitly confirms their food order. Do not set to true until the user says 'yes', 'confirm', 'place the order', or similar confirmation. Always ask for confirmation before booking the order.",
        examples: [true, false]
      },
      {
        type: "boolean",
        name: "reservation_table_booked",
        description: "Set to true ONLY after the customer explicitly confirms their table reservation. Do not set to true until the user says 'yes', 'confirm', 'book it', or similar confirmation. Always ask for confirmation before booking the table.",
        examples: [true, false]
      },
      {
        type: "string",
        name: "reservation_table_booking_details",
        description: "Extract complete table reservation information from the conversation. Include date, time, party size, customer name, phone number, email, table preferences, seating arrangements, occasion details, and any special requests. Format as JSON object with proper string formatting for all values.",
        examples: [
          '{"date":"01-Sept-2025","time":"2:00 PM","party_size":"2","name":"Nitish","phone":"7876121490","email":"nitishpathania12@gmail.com","table_preference":"window seat","occasion":"anniversary","special_requests":"candlelit table"}',

          '{"date":"15-Oct-2025","time":"7:30 PM","party_size":"4","name":"John Smith","phone":"9876543210","email":"john@email.com","table_preference":"quiet area","occasion":"business dinner","seating_arrangement":"round table"}',

          '{"date":"22-Dec-2025","time":"12:00 PM","party_size":"6","name":"Sarah Johnson","phone":"8765432109","email":"sarah.j@gmail.com","occasion":"birthday","special_requests":"birthday celebration with cake","table_preference":"private dining"}',

          '{"date":"14-Feb-2025","time":"8:00 PM","party_size":"2","name":"Michael Brown","phone":"9988776655","email":"michael.b@email.com","table_preference":"booth","occasion":"date night","special_requests":"surprise dessert"}',

          '{"date":"10-Nov-2025","time":"6:30 PM","party_size":"8","name":"Lisa Davis","phone":"7766554433","email":"lisa.davis@company.com","table_preference":"private dining","occasion":"celebration","seating_arrangement":"long table","special_requests":"separate checks needed"}',

          '{"date":"25-Dec-2025","time":"1:00 PM","party_size":"12","name":"Robert Wilson","phone":"6655443322","email":"robert.w@email.com","table_preference":"outdoor patio","occasion":"family gathering","seating_arrangement":"separate tables","special_requests":"high chairs needed for 2 children"}'
        ]
      },
      {
        type: "string",
        name: "order_type",
        description: "Extract complete order Order Type. Weather it is Home Delivery or Dine In. Format as String.",
        examples: [
          '[{"item":{"id":"ABC123XYZ"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]',
          '[{"item":{"id":"DEF456UVW"},"name":"Pizza Margherita","price":1200,"quantity":1},{"item":{"id":"GHI789RST"},"name":"Garlic Bread","price":300,"quantity":2}]'
        ]
      },

      // {
      //   type: "string",
      //   name: "order_details",
      //   description: "Extract complete order information in Clover format. Must include Clover item IDs, item names, quantities, and prices in cents. Format as JSON array.Get item id from Knowledebase Source MenuItem .eq.('id': 'MVTMF051FZZJA') ",
      //   examples: [
      //     '[{"item":{"id":"ABC123XYZ"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]',
      //     '[{"item":{"id":"DEF456UVW"},"name":"Pizza Margherita","price":1200,"quantity":1},{"item":{"id":"GHI789RST"},"name":"Garlic Bread","price":300,"quantity":2}]'
      //   ]
      // },
      // {
      //   type: "string",
      //   name: "order_items",
      //   description: "Complete list of ordered items in Clover line items format. Each item must have Clover item ID (from inventory), name, price in cents, and quantity.Get item id from Knowledebase Source MenuItem .eq.('id': 'MVTMF051FZZJA') ",
      //   examples: [
      //     '[{"item":{"id":"ABC123XYZ"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]',
      //     '[{"item":{"id":"DEF456"},"name":"Dal Makhani","price":1800,"quantity":1},{"item":{"id":"GHI789"},"name":"Naan","price":300,"quantity":3}]'
      //   ]
      // },

      {
        type: "string",
        name: "order_details",
        description: `CRITICAL: This must contain ACTUAL Clover item IDs from knowledge base.
        
        PROCESS TO FOLLOW:
        1. Customer mentions item: "I want Paneer Butter Masala"
        2. You search knowledge base for: "Paneer Butter Masala"
        3. You find the object with "name": "Paneer Butter Masala" 
        4. You extract the "id" field 
        5. You format it as: [{"item":{"id":"ACTUAL-Clover-item-Id"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]
        
        NEVER use these placeholder IDs:
        - ABC123XYZ
        - DEF456UVW
        - ITEM_ID
        - Any generic or made-up ID
   `,
        examples: [
          '[{"item":{"id":"ACTUAL-Clover-item-Id"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]',
          '[{"item":{"id":"ACTUAL-Clover-item-Id"},"name":"Okanagan Spring Pale Ale","price":799,"quantity":1}]',
          '[{"item":{"id":"ACTUAL-Clover-item-Id"},"name":"Corona (Mexico)","price":799,"quantity":2}]'
        ]
      },
      {
        type: "string",
        name: "order_items",
        description: "Complete list of ordered items with VERIFIED Clover item IDs. Each item must have: actual ID from knowledge base (not placeholder), name, price in cents, quantity.",
        examples: [
          '[{"item":{"id":"ACTUAL-Clover-item-Id"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]',
          '[{"item":{"id":"ACTUAL-Clover-item-Id"},"name":"Peller Estates Pinot Grigio","price":2499,"quantity":1}]'
        ]
      },
      // ========== CUSTOMER INFORMATION ==========
      {
        type: "string",
        name: "customer_name",
        description: "Extract the customer's full name from the conversation",
        examples: ["Raj Kumar", "Priya Sharma", "John Doe"]
      },
      {
        type: "string",
        name: "customer_email",
        description: "Extract the customer's email address. Must contain @ symbol.",
        examples: ["raj.kumar@example.com", "priya123@gmail.com"]
      },
      {
        type: "string",
        name: "customer_phone",
        description: "Extract the customer's phone number. Should be 8-12 digits.",
        examples: ["9876543210", "7876121490"]
      },

      // ========== CALL PURPOSE ==========
      {
        type: "string",
        name: "call_purpose",
        description: "The main reason for the customer's call",
        examples: [
          "Place new food order",
          "Check order status",
          "Modify existing order",
          "Cancel order",
          "Menu inquiry",
          "Table reservation"
        ]
      },
      {
        type: "string",
        name: "call_summary",
        description: "Brief 2-3 sentence summary of the entire call conversation",
        examples: [
          "Customer called to place an order for 2 Paneer Butter Masala and 1 Pizza. Provided delivery address in Sector 12, Chandigarh. Order was successfully placed in Clover POS with order ID ABC123.",
          "Customer inquired about their order status. Agent retrieved details from Clover and confirmed order is being prepared."
        ]
      },

      // ========== ORDER STATUS ==========
      {
        type: "boolean",
        name: "order_placed",
        description: "Set to true ONLY if a new order was successfully created in Clover POS and confirmed.",
        examples: [true, false]
      },
      {
        type: "string",
        name: "clover_order_id",
        description: "The Clover order ID generated after order creation or discussed during call",
        examples: ["ABC123XYZ", "DEF456UVW", "GHI789RST"]
      },
      {
        type: "string",
        name: "order_value_estimate",
        description: "Estimated total order value if discussed or calculated from menu prices",
        examples: ["₹850", "$12.50", "₹1200"]
      },
      {
        type: "string",
        name: "special_instructions",
        description: "Any special cooking instructions, dietary requirements, or delivery notes",
        examples: [
          "Extra spicy, no onions",
          "Make it less oily, add extra cheese",
          "Call before delivery, gate code is 1234"
        ]
      },

      // ========== DELIVERY ADDRESS ==========
      {
        type: "string",
        name: "shipping_address",
        description: "Complete delivery address including flat/house number, building name, street, area.",
        examples: [
          "Flat 301, Building A, Green Valley Apartments, Sector 12",
          "House No. 45, MG Road, Near City Mall"
        ]
      },
      {
        type: "string",
        name: "shipping_city",
        description: "City name for delivery",
        examples: ["Chandigarh", "Mumbai", "Delhi", "Bangalore"]
      },
      {
        type: "string",
        name: "shipping_state",
        description: "State name for delivery",
        examples: ["Punjab", "Maharashtra", "Delhi", "Karnataka"]
      },
      {
        type: "string",
        name: "shipping_pincode",
        description: "6-digit pincode for delivery area.",
        examples: ["160012", "400001", "110001"]
      },
      {
        type: "string",
        name: "shipping_landmark",
        description: "Nearby landmark mentioned for easier delivery",
        examples: [
          "Near HDFC Bank",
          "Opposite McDonald's",
          "Behind City Hospital"
        ]
      },

      // ========== ORDER MODIFICATIONS ==========
      {
        type: "boolean",
        name: "order_status_checked",
        description: "True if customer checked the status of an existing order in Clover",
        examples: [true, false]
      },
      {
        type: "boolean",
        name: "order_modified",
        description: "True if customer modified an existing Clover order (added/removed items, changed address)",
        examples: [true, false]
      },
      {
        type: "string",
        name: "modification_type",
        description: "Type of modification made to the Clover order",
        examples: [
          "Added items",
          "Removed items",
          "Changed delivery address",
          "Updated special instructions",
          "No modification"
        ]
      },
      {
        type: "boolean",
        name: "order_cancelled",
        description: "True if customer cancelled their Clover order during this call",
        examples: [true, false]
      },
      {
        type: "string",
        name: "cancellation_reason",
        description: "Reason provided by customer for Clover order cancellation",
        examples: [
          "Changed mind",
          "Ordered by mistake",
          "Too long delivery time",
          "Found better option"
        ]
      },

      // ========== CLOVER-SPECIFIC FIELDS ==========
      {
        type: "string",
        name: "clover_line_items",
        description: "Line items in exact Clover API format with item IDs from Clover inventory. Include item ID, name, price in cents, and quantity.",
        examples: [
          '[{"item":{"id":"ABC123"},"name":"Paneer Butter Masala","price":2500,"quantity":2}]',
          '[{"item":{"id":"DEF456"},"name":"Pizza","price":1200,"quantity":1},{"item":{"id":"GHI789"},"name":"Coke","price":150,"quantity":2}]'
        ]
      },
      {
        type: "string",
        name: "payment_method",
        description: "Payment method mentioned or used for the order",
        examples: ["Cash on Delivery", "Card", "UPI", "Online Payment", "Not Discussed"]
      }

    ];
  }

  return [];
}
export function appointmentBooking(businessType) {
  if (businessType === "Restaurant") {
    return [];
  }
  else {
    return [
      {
        "type": "boolean",
        "name": "appointment_booked",
        "description": "Determine if appointment was successfully booked during the call",
        "examples": [true, false]
      },
      {
        "type": "string",
        "name": "appointment_date",
        "description": "Extract the exact appointment date mentioned by customer. Format: YYYY-MM-DD",
        "examples": ["2025-01-15", "2025-02-20", "2025-03-10"]
      },
      {
        "type": "string",
        "name": "appointment_time",
        "description": "Extract the exact appointment time mentioned by customer. Format: HH:MM AM/PM",
        "examples": ["10:00 AM", "2:30 PM", "9:15 AM"]
      },
      {
        "type": "string",
        "name": "appointment_timezone",
        "description": "Extract timezone if mentioned, otherwise use default. Format: America/Los_Angeles style",
        "examples": ["America/Los_Angeles", "America/New_York", "UTC"]
      },
    ]
  }

}
